const RATE_LIMIT_COOLDOWN_KEY = 'global-rate-limit-cooldown';
const COOLDOWN_DURATION = 20 * 60 * 1000; // 20 minutes
const TOAST_SHOWN_KEY = 'rate-limit-toast-shown';

export function isInRateLimitCooldown() {
  try {
    const cooldownEnd = localStorage.getItem(RATE_LIMIT_COOLDOWN_KEY);
    if (!cooldownEnd) {
      console.log('✅ No cooldown active');
      return false;
    }
    const remaining = parseInt(cooldownEnd) - Date.now();
    
    if (remaining > 0) {
      console.log(`⏸️ Cooldown active: ${formatRemainingTime(remaining)} remaining`);
      return true;
    }
    
    // Cooldown expired, clear it
    console.log('✅ Cooldown expired, clearing');
    clearRateLimitCooldown();
    return false;
  } catch (error) {
    console.error('Error checking cooldown:', error);
    return false;
  }
}

export function setRateLimitCooldown() {
  try {
    const cooldownEnd = Date.now() + COOLDOWN_DURATION;
    localStorage.setItem(RATE_LIMIT_COOLDOWN_KEY, String(cooldownEnd));
    console.log(`🚫 Rate limit cooldown set until ${new Date(cooldownEnd).toLocaleTimeString()}`);
  } catch (error) {
    console.error('Error setting cooldown:', error);
  }
}

export function clearRateLimitCooldown() {
  try {
    localStorage.removeItem(RATE_LIMIT_COOLDOWN_KEY);
    sessionStorage.removeItem(TOAST_SHOWN_KEY);
    console.log('✅ Rate limit cooldown cleared');
  } catch (error) {
    console.error('Error clearing cooldown:', error);
  }
}

export function getRemainingCooldownTime() {
  try {
    const cooldownEnd = localStorage.getItem(RATE_LIMIT_COOLDOWN_KEY);
    if (!cooldownEnd) return 0;
    const remaining = parseInt(cooldownEnd) - Date.now();
    return Math.max(0, remaining);
  } catch {
    return 0;
  }
}

export function shouldShowRateLimitToast() {
  try {
    const shown = sessionStorage.getItem(TOAST_SHOWN_KEY);
    return !shown;
  } catch {
    return true;
  }
}

export function markRateLimitToastShown() {
  try {
    sessionStorage.setItem(TOAST_SHOWN_KEY, 'true');
  } catch {}
}

export function formatRemainingTime(ms) {
  const minutes = Math.ceil(ms / 60000);
  return `${minutes} minute${minutes !== 1 ? 's' : ''}`;
}